import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { ShimmerAvatar } from '..';
import { ShimmerContentCardContainer, ShimmerSimpleCardMedia, ShimmerSimpleCardContent, getThemeConfig, ShimmerSimpleCardWrapper } from '../styles';
import ShimmerBodyText from './ShimmerBodyText';
import ShimmerTitleText from './ShimmerTitleText';

var ShimmerSimpleCard = function ShimmerSimpleCard(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? "".concat(300 / 16, "rem") : _ref$width,
      _ref$media = _ref.media,
      media = _ref$media === void 0 ? false : _ref$media,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["width", "media", "theme"]);

  var componentTheme = useComponentTheme({
    name: 'Shimmer',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(ShimmerContentCardContainer, _extends({
    customTheme: componentTheme,
    $width: width
  }, props), /*#__PURE__*/React.createElement(ShimmerSimpleCardWrapper, null, media ? /*#__PURE__*/React.createElement(ShimmerSimpleCardMedia, {
    customTheme: componentTheme,
    "data-test": "".concat(props['data-test'], "-media")
  }) : null, /*#__PURE__*/React.createElement(ShimmerSimpleCardContent, null, media ? null : /*#__PURE__*/React.createElement(ShimmerAvatar, {
    size: "sm",
    content: false,
    width: "fit-content"
  }), /*#__PURE__*/React.createElement(ShimmerTitleText, {
    center: true
  }), /*#__PURE__*/React.createElement(ShimmerBodyText, {
    line: 2
  }))));
};

ShimmerSimpleCard.displayName = 'ShimmerSimpleCard';
export default ShimmerSimpleCard;